import { Injectable, inject } from '@angular/core';

import { UserSessionService } from '../services/user-session.service';

@Injectable({ providedIn: 'root' })
export class NotificationDisplayService {
  private readonly session = inject(UserSessionService);

  isUserActivelyViewingApp(): boolean {
    if (typeof document === 'undefined') return false;
    return document.visibilityState === 'visible' && document.hasFocus();
  }

  canShow(): boolean {
    if (typeof window === 'undefined' || typeof Notification === 'undefined') return false;
    if (Notification.permission !== 'granted') return false;
    return !this.isUserActivelyViewingApp();
  }

  show(title: string, body: string, tag: string): void {
    if (!this.session.user()) return;
    if (!this.canShow()) return;

    try {
      new Notification(title, { body, tag });
    } catch {
      // Older browsers or restrictive environments may throw.
    }
  }
}
